module.exports = __webpack_public_path__ + "img/slider1.447b4a2f.png";